import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import trans, { isRTL } from "../../../../utils";
import { popupcontext } from "../../../../context/Popupscontext";

export default function OfflineFormHeader({ title, subtitle }) {
	const { setIsEditing } = useContext(popupcontext);
	const navigate = useNavigate();
	const location = useLocation();
	const pathname = location.pathname;
	const cancelbtn = () => {
		setIsEditing(false);
		if (pathname.includes("snag-offline-control")) {
			navigate("/snag-list");
		} else if (pathname.includes("IR-offline-control")) {
			navigate("/IR");
		}
	};
	return (
		<div
			className="setup-header"
			style={{
				height: "auto",
				paddingBlock: "16px",
				backgroundColor: "#FEF3E8",
			}}
		>
			<div>
				<div
					style={{
						fontWeight: "600",
						color: "#000000E0",
						fontSize: "16px",
						marginBottom: "2px",
					}}
				>
					{trans(title)}
				</div>
				<div
					style={{
						fontWeight: "500",
						color: "#FA8C16",
						fontSize: "12px",
						display: "flex",
						alignItems: "center",
					}}
				>
					<div>{trans(subtitle)}</div>
				</div>
			</div>
			<div className="setup-header-tool" onClick={cancelbtn}>
				<img src={`${process.env.PUBLIC_URL}/assets/Close.svg`} alt="back" />
			</div>
		</div>
	);
}
